import { defineStore } from "pinia";
import { useArchivalFiltersStore } from "@/stores/archivalFilters";

export const useArchivalStore = defineStore("archival", {
    state: () => ({
        step: 1,
        isResult: false,
    }),

    actions: {
        nextStep() {
            const filtersStore = useArchivalFiltersStore();

            // STEP 1 → 2
            if (this.step === 1) {
                filtersStore.checkRequireData();
                if (filtersStore.error) return this.step;

                this.step = 2;
                this.isResult = false;
                return this.step;
            }

            // STEP 2 → 3
            if (this.step === 2) {
                this.step = 3;
                this.isResult = false;
                return this.step;
            }

            // STEP 3 → 4 (RESULTS)
            if (this.step === 3) {
                filtersStore.checkRequireData();
                if (filtersStore.error) {
                    this.isResult = false;
                    return this.step;
                }

                this.step = 4;
                this.isResult = true;
                return this.step;
            }

            return this.step;
        },

        previousStep() {
            if (this.step > 1) {
                this.step--;
            }

            if (this.step < 4) {
                this.isResult = false;
            }

            // Powrót na krok 1 (wybór lokalizacji i zakresu dat) — data "do" ma być zawsze aktualna.
            if (this.step === 1) {
                useArchivalFiltersStore().refreshDateTimeEnd();
            }

            return this.step;
        },

        clear() {
            this.step = 1;
            this.isResult = false;
            useArchivalFiltersStore().refreshDateTimeEnd();
        },
    },
});
